import { useState } from 'react';
import { checkIfFiltered as defaultCheckIfFiltered } from '../../js/default-handlers/check-if-filtered/checkIfFiltered';
import { checkIfSelected as defaultCheckIfSelected } from '../../js/default-handlers/check-if-selected/checkIfSelected';
import { handleClick as defaultHandleClick } from '../../js/default-handlers/handle-click/handleClick';
import type {
  UseChartSetingsProps,
  UseChartSettingsCheckHandler,
  UseChartSettingsClickHandler,
  UseChartSettingsResolvedProps,
} from './useChartSettings.types';

/** Uses caller handlers when supplied and the package defaults otherwise. */
export const useChartSettings = (
  props: UseChartSetingsProps,
): UseChartSettingsResolvedProps => {
  
  const [internal_selected, setSelected] = useState<UseChartSetingsProps['selected']>();
  const selected = props.handleClick ? props.selected : internal_selected;

  const handleClick: UseChartSettingsClickHandler = props.handleClick ?? (
    (data, type, handler_props) => defaultHandleClick(
      data,
      type,
      {
        ...handler_props,
        selected,
        setSelected: (next_selected) => setSelected(next_selected),
      },
    )
  );

  const checkIfSelected: UseChartSettingsCheckHandler = (
    data,
    type,
    _selected,
    handler_props,
  ) => (props.checkIfSelected ?? defaultCheckIfSelected)(
      data,
      type,
      selected,
      { ...handler_props, selected },
    );

  const checkIfFiltered: UseChartSettingsCheckHandler = (
    data,
    type,
    _selected,
    handler_props,
  ) => props.checkIfFiltered
    ? props.checkIfFiltered(data, type, selected, { ...handler_props, selected })
    : defaultCheckIfFiltered(
      data,
      type,
      selected,
      {
        ...handler_props,
        selected,
        checkIfSelected,
      },
    );

  return {
    ...props,
    selected,
    handleClick,
    checkIfSelected,
    checkIfFiltered,
  };
};
